import { DiContainer } from '@/modules/di/di-container';
import { BusinessOffersService } from '../services/business-offers.service';
import { notification } from 'antd';

const businessOffersService = DiContainer.get(BusinessOffersService);

export const multiApproveBusinessOffers = async (ids: number[]) => {
  try {
    const res = await businessOffersService.approveBusinessOffers(ids);
    if (res.success)
      return notification.success({
        message:
          ids.length > 1
            ? 'Сделки успешно оформлены и переведены в раздел "оформленные сделки"'
            : 'Сделка успешно оформлена и переведена в раздел "оформленные сделки"',
      });
    console.log(res);
    return notification.warning({
      message:
        ids.length > 1
          ? 'При оформлении сделок возникла ошибка. Попробуйте, пожалуйста, позже'
          : 'При оформлении сделки возникла ошибка. Попробуйте, пожалуйста, позже',
    });
  } catch (err) {
    console.log(err);
    return notification.warning({
      message:
        ids.length > 1
          ? 'При оформлении сделок возникла ошибка. Попробуйте, пожалуйста, позже'
          : 'При оформлении сделки возникла ошибка. Попробуйте, пожалуйста, позже',
    });
  }
};
